export default `
    ... on ds_GoogleTranslate_GlobalSet  {
        id
        name
        __typename
        googleTranslate_Toggle
        googleTranslate_Options(label: true)
        googleTranslate_OptionsValue: googleTranslate_Options(label: false)
    }
`